/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable default-case */
/* eslint-disable no-undef */
/* eslint-disable no-multi-assign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, Fragment, useContext } from 'react';
import { split } from 'apollo-link';
import { getMainDefinition } from 'apollo-utilities';
import { WebSocketLink } from 'apollo-link-ws';
import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { ApolloProvider } from '@apollo/react-hooks';
import { useHistory } from 'react-router-dom';
import { UserAuthenticationContext } from './token_provider';
import 'dotenv/config';

function GQLProvider(props) {
  const { session } = useContext(UserAuthenticationContext);
  const history = useHistory();

  if (!session.id_token) return <div>loading </div>;

  const _hsq = (window._hsq = window._hsq || []);
  _hsq.push([
    'identify',
    {
      email: session.id_token_claims.emails[0],
    },
  ]);

  const getGraphQLEndpoint = connection => {
    const graphqlEndpoint =
      process.env && process.env.REACT_APP_ENVIORNMENT === 'production'
        ? `${connection}://devapi.liqural.com/v1/graphql`
        : `${connection}://devapi.liqural.com/beta/v1/graphql`;
    return graphqlEndpoint;
  };

  const httpLink = new HttpLink({
    uri: getGraphQLEndpoint('https'),
    headers: { authorization: `Bearer ${session.id_token}` },
  });

  const wsLink = new WebSocketLink({
    uri: getGraphQLEndpoint('wss'),
    options: {
      reconnect: true,
      connectionParams: {
        headers: { authorization: `Bearer ${session.id_token}` },
      },
    },
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (networkError)
      networkError.forEach(({ message, locations, path }) => {
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
        message.error('Un-Authorized! Please Signin Again.');
        localStorage.removeItem('authToken');
        window.location.replace('/');
      });
    if (networkError) console.log(`[Network error]: ${networkError}`);
  });

  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    },
    wsLink,
    from([errorLink, httpLink]),
  );

  const client = new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache(),
  });

  return (
    <div className="App">
      <header>{true && <ApolloProvider client={client}>{props.children}</ApolloProvider>}</header>
    </div>
  );
}

export default GQLProvider;
